import { CheckCircle2, Clock, Hourglass, Send, BadgeCheck } from "lucide-react";

export function StatusPill({ status }) {
  if (status === "received") {
    return (
      <span
        data-testid="status-badge-received"
        className="inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full text-xs font-medium bg-emerald-100 dark:bg-emerald-950/60 text-emerald-800 dark:text-emerald-300 border border-emerald-300 dark:border-emerald-800"
      >
        <CheckCircle2 className="w-3 h-3" /> Payment Received
      </span>
    );
  }
  if (status === "Requested") {
    return (
      <span
        data-testid="status-badge-requested"
        className="inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full text-xs font-medium bg-sky-100 dark:bg-sky-950/60 text-sky-800 dark:text-sky-300 border border-sky-300 dark:border-sky-800"
      >
        <Hourglass className="w-3 h-3" /> Requested
      </span>
    );
  }
  if (status === "Assigned") {
    return (
      <span data-testid="status-badge-assigned" className="inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full text-xs font-medium bg-indigo-100 text-indigo-800 border border-indigo-300">
        <Send className="w-3 h-3" /> Assigned
      </span>
    );
  }
  if (status === "Paid - Pending Approval") {
    return (
      <span data-testid="status-badge-paid-pending" className="inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full text-xs font-medium bg-violet-100 text-violet-800 border border-violet-300">
        <Clock className="w-3 h-3" /> Paid · Pending Approval
      </span>
    );
  }
  if (status === "Approved" || status === "approved") {
    return (
      <span data-testid="status-badge-approved" className="inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full text-xs font-medium bg-emerald-100 text-emerald-800 border border-emerald-300">
        <BadgeCheck className="w-3 h-3" /> Approved
      </span>
    );
  }
  return (
    <span
      data-testid="status-badge-pending"
      className="inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full text-xs font-medium bg-amber-100 dark:bg-amber-950/60 text-amber-800 dark:text-amber-300 border border-amber-300 dark:border-amber-800"
    >
      <Clock className="w-3 h-3" /> Pending Payment
    </span>
  );
}

export function LiveIndicator() {
  return (
    <span
      data-testid="live-status-indicator"
      className="inline-flex items-center gap-2 px-3 py-1 rounded-full text-xs font-semibold bg-emerald-500/10 text-emerald-600 dark:text-emerald-400 border border-emerald-500/20"
    >
      <span className="w-2 h-2 rounded-full bg-emerald-500 animate-pulse ring-4 ring-emerald-500/20" />
      Live
    </span>
  );
}
